<div #container
     (mousedown)="onMouseDown($event)"
     (mousemove)="onMouseMove($event)"
     (mouseup)="onMouseUp($event)"
     (swipeleft)="onSwipe($event, 'forward')"
     (swiperight)="onSwipe($event, 'backwards')"
     (touchend)="onMouseUp($event)"
     (touchmove)="onMouseMove($event)"
     (touchstart)="onMouseDown($event)"
     [attr.data-id]="page.id"
     [attr.data-index]="page.index"
     [ngStyle]="{
        'height.px': imageHeight,
        'width.px': imageWidth
     }"
     class="bookviewer-single-page-container">

    @if (isLeftPage && applicationStateService.currentViewMode.showPageTurner) {
        <div
                class="page-turner-container left">
            <app-page-turner [previous]="true"></app-page-turner>
        </div>
    }

    @if (!isCenterPage && isLeftPage) {
        <div
                class="page-shadow-container left"></div>
    }

    @if (!loading && (showLeftFavorite || showRightFavorite)) {
        <app-page-favorite
                [isLeft]="showLeftFavorite"
                [page]="page"></app-page-favorite>
    }


    @if (!applicationStateService.isOfflineModeEnabled) {
        <app-share-dropdown [context]="{page: page}"
                            [position]="showLeftFavorite ? 'left' : 'right'"></app-share-dropdown>
    }


    <img #img
         (dragstart)="onDragStart($event)"
         (load)="onLoad()"
         (tap)="onTap($event)"
         [attr.height]="imageHeight"
         [attr.src]="imgSrc"
         [attr.width]="imageWidth"
         alt="Seite {{ page.index }}"
         class="bookviewer-page"
    />

    @if (!isCenterPage && isRightPage) {
        <div
                class="page-shadow-container right"></div>
    }


    @if (isRightPage && applicationStateService.currentViewMode.showPageTurner && pageService.isTurnRightPossible()) {
        <div
                class="page-turner-container right">
            <app-page-turner [next]="true"></app-page-turner>
        </div>
    }

    @if (searchedTermPosition) {
        <div [attr.data-bs-container]="popoverContainer"
             [ngStyle]="{
     'top.%': searchedTermPosition.y - 0.3,
     'left.%': searchedTermPosition.x -0.3,
     'height.%': searchedTermPosition.h + 0.6,
     'width.%': searchedTermPosition.w + 0.6
     }"
             class="search-term"
             data-bs-html="true"
             data-bs-toggle="popover"
             data-bs-trigger="focus"
             id="dictionaryPopoverAnchor"></div>
    }

    @if (!loading) {
        @for (bookFeature of whiteboards$ | async; track bookFeature) {
            <app-book-feature
                    [moveableBookFeature]="bookFeature"
                    [page]="page"></app-book-feature>
        }
        @if (bookFeatureActivationService.rectsVisible) {
            @for (bookFeature of bookFeatures?.rects; track bookFeature) {
                <app-book-feature [moveableBookFeature]="bookFeature"
                                  [page]="page"></app-book-feature>
            }
        }
        @if (bookFeatureActivationService.textSelectionsVisible) {
            @for (bookFeature of bookFeatures?.textSelections; track bookFeature) {
                <app-book-feature
                        [moveableBookFeature]="bookFeature"
                        [page]="page"></app-book-feature>
            }
        }
        @if (bookFeatureActivationService.linksVisible) {
            @for (bookFeature of bookFeatures?.links; track bookFeature) {
                <app-book-feature [moveableBookFeature]="bookFeature" [page]="page"
                                  class="links"></app-book-feature>
            }
        }
        @if (bookFeatureActivationService.audiosVisible) {
            @for (bookFeature of bookFeatures?.audios; track bookFeature) {
                <app-book-feature [moveableBookFeature]="bookFeature"
                                  [page]="page"></app-book-feature>
            }
        }
        @if (bookFeatureActivationService.videosVisible) {
            @for (bookFeature of bookFeatures?.videos; track bookFeature) {
                <app-book-feature [moveableBookFeature]="bookFeature"
                                  [page]="page"></app-book-feature>
            }
        }
        @if (bookFeatureActivationService.readspeakerElementsVisible) {
            @for (bookFeature of bookFeatures?.readspeakerElements; track bookFeature) {
                <app-page-readspeaker
                        [page]="page"
                        [readspeakerElement]="bookFeature"></app-page-readspeaker>
            }
        }
        @if (bookFeatures?.quickLinks) {
            @for (bookFeature of bookFeatures.quickLinks.eSquirrelQuickLinks; track bookFeature) {
                <app-book-feature
                        [moveableBookFeature]="bookFeature"
                        [page]="page"></app-book-feature>
            }
            @for (bookFeature of bookFeatures?.quickLinks.genericQuickLinks; track bookFeature) {
                <app-book-feature
                        [moveableBookFeature]="bookFeature"
                        [page]="page"></app-book-feature>
            }
            @for (bookFeature of bookFeatures?.quickLinks.gmtQuickLinks; track bookFeature) {
                <app-book-feature
                        [moveableBookFeature]="bookFeature"
                        [page]="page"></app-book-feature>
            }
            @for (bookFeature of bookFeatures?.quickLinks.hsmQuickLinks; track bookFeature) {
                <app-book-feature
                        [moveableBookFeature]="bookFeature"
                        [page]="page"></app-book-feature>
            }
            @for (bookFeature of bookFeatures?.quickLinks.digiFitQuicklinks; track bookFeature) {
                <app-book-feature
                        [moveableBookFeature]="bookFeature"
                        [page]="page"></app-book-feature>
            }
            @if (applicationStateService.bookConfig.displayDropdown) {
                @for (bookFeature of bookFeatures.quickLinks.all(); track bookFeature) {
                    <app-quicklink-dropdown
                            [page]="page"
                            [quickLink]="bookFeature"></app-quicklink-dropdown>
                }
            }
            @for (quickLink of bookFeatures?.quickLinks.genericQuickLinks; track quickLink) {
                <app-quicklink-overlay
                        [page]="page"
                        [quickLink]="quickLink"></app-quicklink-overlay>
            }
        }
        @for (searchResult of searchResults; track searchResult) {
            <search-result-rect [page]="page"
                                [searchResult]="searchResult"></search-result-rect>
        }
    }

    @if (bookFeatureActivationService.textSelectionsVisible) {
        <app-page-text-boxes
                [active]="true"></app-page-text-boxes>
    }


    @if (bookFeatureActivationService.pageDrawingsVisible) {
        <div (tap)="onTap($event)">
            @if (bookFeatures?.pageDrawing) {
                <app-page-canvas
                        [height]="imageHeight"
                        [pageDrawing]="bookFeatures.pageDrawing"
                        [width]="imageWidth"></app-page-canvas>
            }
        </div>
    }

    <ng-container>
        <ng-container #childHost/>
    </ng-container>
</div>






